angular.module('app').service('ScorecardUtils', function($http) {
    return {
        'chart': {
            'type': 'bar',
            'data': {
                'labels': [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ],
                'datasets': [
                    {
                        'label': 'Kids Needed',
                        'backgroundColor': 'rgba(0, 0, 0, 0)',
                        'borderWidth': 0,
                        'data': [],
                        'yAxisID': 'y1',
                        'stack': 'thisYear',
                        'datalabels': {
                            'display': function(context) {
                                return context.dataset.data[context.dataIndex] > 0;
                            },
                            'align': 'end',
                            'anchor': 'end',
                            'borderRadius': 4,
                            'color': 'white',
                            'formatter': Math.round,
                            'padding': 6,
                            'backgroundColor': 'rgba(255, 0, 0, 0.5)'
                        }
                    },
                    {
                        'label': 'This Year',
                        'backgroundColor': '#9900ff',
                        'data': [],
                        'stack': 'thisYear',
                        'datalabels': {
                            'color': 'white',
                            'active': true,
                        }
                    },
                    {
                        'label': 'Forecast',
                        'backgroundColor': '#999999',
                        'data': [],
                        'stack': 'forecast'
                    },
                    {
                        'label': 'Last Year',
                        'backgroundColor': '#ffd967',
                        'data': [],
                        'stack': 'lastYear'
                    },
                    {
                        'type': 'line',
                        'stepped': 'middle',
                        'label': 'Goal',
                        'pointRadius': 0,
                        'fill': true,
                        'backgroundColor': 'rgba(217, 211, 234, 0.5)',
                        'datalabels': {'labels': {'anchor': null}} 
                    },
                ]
            },
            'options': {
                'scales': {
                    'y': {
                        'type': 'linear',
                        'display': true,
                        'position': 'left'
                    },
                    'y1': {
                        'type': 'linear',
                        'display': false,
                    }
                },
                'plugins': {
                    'datalabels': {
                        'font': {'size': '10px'}
                    },
                    'legend': {
                        'labels': {
                            'usePointStyle': true
                        }

                    }
                },
            },
            'plugins': [ChartDataLabels]
        },
        'goal_cols':  [
            'sales_child',
            'january',
            'february',
            'march',
            'april',
            'may',
            'june',
            'july',
            'august',
            'september',
            'october',
            'november',
            'december',
        ],
        'map_data_to_graph_array': function(data, year) {
            return this.goal_cols.filter((x) => { return x != 'sales_child' }).map(
                function(col_name) {
                    if(year) {
                        col_name = col_name + ' ' + year;
                    }
                    return data[col_name];
                }
            );
        },
        'refresh_scorecard_goals': function(main) {
            main.scorecard.data.datasets[4].data = this.map_data_to_graph_array(main.goals);
            main.scorecard.data.datasets[3].data = this.map_data_to_graph_array(main.sales, main.lastYear);
            main.scorecard.data.datasets[2].data = this.map_data_to_graph_array(main.forecast, main.thisYear);
            main.scorecard.data.datasets[1].data = this.map_data_to_graph_array(main.sales, main.thisYear);
            main.scorecard.data.datasets[0].data = main.kids_needed.slice(1);

            function filter_max(args, fn) {
                if(!fn) {
                    fn = Math.max;
                }
                return fn.apply(Math, args.filter(function(val) {
                    return !isNaN(val);
                }));
            }

            var kids_max = filter_max(main.scorecard.data.datasets[0].data);

            if(isFinite(kids_max)) {
                main.scorecard.options.scales['y1'].suggestedMax = kids_max * 1.1;
            }
            main.scorecard = angular.copy(main.scorecard);

            main.ytd_needed = 0;
            if(main.sales_ytd && main.goalYtd && main.goals['sales_child']) {
                var diff = main.goalYtd - main.sales_ytd;
                if(diff > 0) {
                    main.ytd_needed = diff / main.goals['sales_child'];
                }
            }

            if(main.ytd.data && main.goalYtd) {
                main.ytd.data.datasets[4].data = [main.goalYtd];
                main.ytd.data.datasets[0].data = [main.ytd_needed];
                if(main.ytd_needed) {
                    main.ytd.options.scales['y1'].suggestedMax = main.ytd_needed * 1.5;
                }
                main.ytd = angular.copy(main.ytd);
            }
        },
        'save_goals': function(main) {
            main.editing_goals = false;
            main.loading = $http({
                'method': 'PUT',
                'url': '/api/v1/admin/goal',
                'params': {'year': main.goalYear},
                'data': main.goals,
            }).then(
                function(response) {
                    main.loading = false;
                    main.goals = response.data;
                }
            );
        },
        'update_goal_total': function(main) {
            if(!main.goals) {
                return;
            }

            main.goalTotal = this.goal_cols.reduce(
                function(val, col_name) {
                    if(col_name != 'sales_child' && main.goals[col_name]) {
                        val += main.goals[col_name];
                    }
                    return val;
                },
                0
            );

            var month = new Date().getMonth();
            main.goalYtd = this.goal_cols.slice(1, month+2).reduce(
                function(val, col_name) {
                    if(main.goals[col_name]) {
                        val += main.goals[col_name];
                    }
                    return val;
                },
                0
            );

            main.kids_needed = this.goal_cols.map(function(col) {
                if(col == 'sales_child') {
                    return;
                }

                var goal = main.goals[col];
                if(!goal) {
                    return '';
                }

                var sales = main.sales[col + ' ' + main.thisYear];
                if(!sales) {
                    sales = 0;
                }

                if(sales >= goal) {
                    return null;
                }

                return (goal - sales) / main.goals['sales_child'];
            });

            this.refresh_scorecard_goals(main);
        }
    }
});
